import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { finalize, Observable } from 'rxjs';
import { ConfigurationService } from '../configuration.service';
import { LabpartnerService } from '../labpartner.service';
import { ICInstrumentGroup } from './ic.service.model';

@Injectable({
  providedIn: 'root',
})
export class ICInstrumentGroupService {
  private v1ICInstrumentGroupURL = 'v1/ICInstrumentGroup';

  private apiUrlBase: string;

  constructor(
    private labpartnerService: LabpartnerService,
    private httpClient: HttpClient,
    configService: ConfigurationService,
  ) {
    const config = configService.getConfig();

    this.apiUrlBase = config.apiServiceEndpoint;
    if (!this.apiUrlBase.endsWith('/')) {
      this.apiUrlBase = `${this.apiUrlBase}/`;
    }
  }

  // Experiment functions
  public getInstrumentGroups(): Observable<ICInstrumentGroup[]> {
    this.labpartnerService.setIsLoading(true);
    const url = `${this.apiUrlBase}${this.v1ICInstrumentGroupURL}/GetAll`;
    return this.httpClient
      .get<ICInstrumentGroup[]>(url)
      .pipe(finalize(() => this.labpartnerService.setIsLoading(false)));
  }
}
